import { useTranslation } from 'react-i18next'
import { Form } from 'formik'
import { useFormikContext } from 'formik'
import { Button, TextField } from '@mui/material'

import { ETranslationNs, IVerificationCodeForm } from 'src/types'

import { useStyles } from '../../styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { handleTrimValueOnPaste } from 'src/common/handlers'

export const VerifyStepForm = () => {
  const [t] = useTranslation(ETranslationNs.UserProfile)
  const { isSubmitting, dirty, values, errors, handleChange, setFieldValue } =
    useFormikContext<IVerificationCodeForm>()
  const classes = useStyles()

  const buttonDis = isSubmitting || !dirty || !!Object.keys(errors).length

  return (
    <Form className={classes.totpVerifyForm}>
      <TextField
        autoComplete="off"
        placeholder={t('2fa-code-input-placeholder.v')}
        name="code"
        value={values.code}
        helperText={errors.code ? <HelperWrapper t={errors.code} /> : ' '}
        FormHelperTextProps={{ error: !!errors.code }}
        onChange={handleChange}
        variant="standard"
        onPaste={(event) => handleTrimValueOnPaste(event, values.code, setFieldValue, 'code')}
      />
      <Button variant="contained" type="submit" disabled={buttonDis}>
        <HelperWrapper t="2fa-modal-email-enable-button" ns={ETranslationNs.UserProfile} />
      </Button>
    </Form>
  )
}
